import TagDepartamento from './TagDepartamento';

export default TagDepartamento;